export const initRem = (uiPageWidth, rate) => {
    const docEl = document.documentElement;
    const bodyEl = document.body;
    const recalc = () => {
        const { clientWidth, clientHeight } = docEl;

        if (clientWidth <= clientHeight) {
            // 竖屏
            docEl.style.fontSize = `${rate * (clientWidth / uiPageWidth)}px`;
        } else {
            // 横屏
            docEl.style.fontSize = `${rate * (clientHeight / uiPageWidth)}px`;
        }
        // 重制body的字号为16px，避免html的字号对px的影响
        // 总感觉这段代码会有问题
        bodyEl.style.fontSize = '16px';
    };

    document.addEventListener('DOMContentLoaded', recalc, false);
    window.onresize = recalc;
    recalc();
}